import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactPopupService {
  private isOpenSubject = new BehaviorSubject<boolean>(false);
  public isOpen$ = this.isOpenSubject.asObservable();

  openPopup(): void {
    this.isOpenSubject.next(true);
    document.body.style.overflow = 'hidden';
    document.body.classList.add('popup-open');
  }

  closePopup(): void {
    this.isOpenSubject.next(false);
    document.body.style.overflow = '';
    document.body.classList.remove('popup-open');
  }

  get isOpen(): boolean {
    return this.isOpenSubject.value;
  }
}
